import { render, staticRenderFns } from "./PreviewMaterialComponent.vue?vue&type=template&id=e27def1c&scoped=true&"
import script from "./PreviewMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMaterialComponent.vue?vue&type=style&index=0&id=e27def1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27def1c",
  null
  
)

export default component.exports